import styled, { css } from 'styled-components';
import { Link as RouterLink } from 'react-router-dom';

import { Link as BaseLink } from 'components/FormComponents/FormComponents';
import { Container as BaseContainer } from 'components/Container/Container';
import { colors } from 'global/colors';

export const Container = styled(BaseContainer)`
  @media (max-width: 667px) {
    padding-top: 10px;
    display: block;
  }

  ${(props) =>
    props.noPadding &&
    css`
      padding: 0px !important;
    `}

  ${(props) =>
    props.center &&
    css`
      align-items: center;

      @media (max-width: 667px) {
        align-items: flex-start;
      }
    `}

  ${(props) =>
    props.width &&
    css`
      max-width: ${props.width}px;
      width: 100%;

      @media (max-width: 1366px) {
        width: 100%;
      }

      @media (max-width: 667px) {
        max-width: 1200px;
      }
    `};
`;

export const Link = styled(BaseLink)`
  display: flex;
  align-items: center;
`;

export const UserContainer = styled.div`
  display: flex;
  flex-direction: column;
  color: ${colors.darkGray};
  flex: 0 1 250px;
  margin-right: 20px;

  @media (max-width: 667px) {
    margin-right: 0;
  }
`;

export const UserInfoWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const UserWrapper = styled.div`
  display: flex;
  flex-direction: column;

  @media (max-width: 667px) {
    flex-direction: row-reverse;
    justify-content: space-between;
    align-items: center;
  }
`;

export const UserTextWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const AvatarInput = styled.input.attrs({
  type: 'file',
  accept: 'image/png, image/jpeg',
})`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: none;
`;

export const Avatar = styled.label`
  flex-shrink: 0;
  box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.5);
  border-radius: 50%;
  width: 120px;
  height: 120px;
  margin-bottom: 15px;
  background-image: url(${(props) => props.image || ''});
  background-repeat: no-repeat;
  background-position: center center;
  background-size: cover;
  position: relative;
  overflow: hidden;

  @media (max-width: 667px) {
    width: 100px;
    height: 100px;
    margin: 0 10px;
  }

  ${(props) =>
    props.isEditing &&
    !props.isLoading &&
    css`
      cursor: pointer;

      :after {
        content: '\f030';
        position: absolute;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        height: 100%;
        font-size: 42px;
        color: ${colors.white};
        background: ${colors.darkGray};
        font-family: FontAwesome;
        opacity: 0.7;
      }
    `}
`;

export const LoadingIcon = styled.i.attrs({
  className: 'fa fa-spinner fa-pulse fa-3x fa-fw',
})`
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  opacity: 0.7;
  color: ${colors.white};
  background: ${colors.darkGray};
`;

export const AvatarContainer = styled.div`
  display: flex;
  align-items: flex-end;
  justify-content: center;

  @media (max-width: 667px) {
    flex-direction: row-reverse;
    align-items: flex-start;
  }
`;

const SwitchableInput = styled.input.attrs((props) => ({
  readOnly: !props.isEditing,
}))`
  background: transparent;
  border: none;
  outline: none;
  color: ${colors.darkGray};
  padding: 0;
  border-radius: 0;

  ${(props) =>
    props.isEditing &&
    css`
      border-bottom: 1px solid ${colors.lightGray2};
    `};
`;

const SwitchableTextarea = styled.textarea.attrs((props) => ({
  readOnly: props.editing === 'false',
}))`
  background: transparent;
  border: none;
  outline: none;
  color: ${colors.darkGray};
  padding: 0;
  resize: none;
  overflow-y: auto;

  ${(props) =>
    props.editing === 'true' &&
    css`
      border-bottom: 1px solid ${colors.lightGray2};
    `}
`;

export const UserName = styled(SwitchableInput)`
  color: ${colors.fsDarkBlue};
  text-transform: uppercase;
  font-weight: bold;
  margin-bottom: 0;
  width: 200px;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 28px;

  @media (max-width: 667px) {
    font-size: 26px;
  }
`;

export const Email = styled(SwitchableInput)`
  font-size: 16px;
  width: 200px;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const InfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  color: ${colors.darkGray};
  margin-top: 10px;
`;

export const InfoLabelContainer = styled.div`
  display: flex;
  align-items: center;
`;

export const InfoLabel = styled(SwitchableInput)`
  font-size: 16px;
  display: flex;
  align-items: center;
  line-height: 20px;
  width: 100%;
`;

export const Icon = styled.div`
  min-width: ${(props) => props.size || 15}px;
  width: ${(props) => props.size || 15}px;
  display: flex;
  justify-content: center;

  :after {
    content: '${(props) => props.icon}';
    font-family: FontAwesome;
    font-size: ${(props) => props.size || 16}px;
    line-height: ${(props) => props.size || 16}px;
  }

  ${(props) =>
    props.spin &&
    css`
      animation-name: spin;
      animation-duration: 4000ms;
      animation-iteration-count: infinite;
      animation-timing-function: linear;
      @keyframes spin {
        from {
          transform: rotate(0deg);
        }
        to {
          transform: rotate(360deg);
        }
      }
    `}

  ${(props) =>
    !props.noMargin &&
    css`
      margin-right: 8px;
    `}

  ${(props) =>
    props.onClick &&
    css`
      cursor: pointer;
    `}
`;

export const InfoSection = styled.div`
  margin-top: 20px;
  display: flex;
  flex-direction: column;
  @media (max-width: 667px) {
    flex: 0 1
      ${(props) => {
        if (props.full) {
          return 100;
        }
        if (props.half) {
          return 48;
        }
        return 32;
      }}
    :last-child {
      margin-right: 0;
    }
  }
`;

export const InfoSectionHeader = styled.span`
  text-transform: uppercase;
  font-weight: bold;
  color: ${colors.fsDarkBlue};
  font-size: 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const InfoSectionContainer = styled.div`
  display: flex;
  position: relative;
`;

export const InfoSectionContent = styled(SwitchableTextarea)`
  font-size: 14px;
  color: ${colors.darkGray};
  margin: 0;
  word-break: break-word;
  width: 100%;
  overflow: hidden;
`;

export const InfoSectionLabel = styled(SwitchableInput)`
  font-size: 16px;
  color: ${colors.darkGray};
  margin: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
  padding-right: 25px;
`;

export const RightContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  align-items: flex-end;

  :after {
    content: '';
    flex: 1 1 auto;
  }
`;

export const SkillWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: flex-start;

  @media (max-width: 667px) {
    margin-top: 30px;
  }
`;

export const ActivityMainContainer = styled.div`
  position: relative;
  background: ${colors.white};
  border-radius: 5px;
  width: 100%;
  flex: 1 1 48%;
  margin-bottom: 2%;
  height: ${(props) => props.height || '180'}px;
  display: flex;
  align-items: center;
  overflow: hidden;
  flex-direction: column;
  justify-content: ${(props) => (props.flexStart ? 'flex-start' : 'flex-end')};
  box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.1);

  @media (max-width: 1024px) {
    ${(props) =>
      !props.full &&
      css`
        flex: 1 1 100%;
        margin-right: 0;
        margin-bottom: 20px;
      `}
  }

  @media (max-width: 667px) {
    margin-right: 0;
  }

  ${(props) =>
    props.onClick &&
    css`
      cursor: pointer;
    `}
`;

export const SkillContainer = styled.div`
  position: relative;
  background: ${colors.white};
  border-radius: 5px;
  width: ${(props) => (props.width ? `${props.width}` : '100%')};
  flex: 1 1 48%;
  margin-bottom: 2%;
  margin-right: 2%;
  display: flex;
  align-items: center;
  overflow: hidden;
  flex-direction: column;
  justify-content: ${(props) => (props.flexStart ? 'flex-start' : 'flex-end')};
  box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.1);
  height: ${(props) => props.height || '180'}px;

  @media (max-width: 1024px) {
    width: 100%;
    ${(props) =>
      !props.full &&
      css`
        flex: 1 1 100%;
        margin-right: 0;
        margin-bottom: 20px;
      `}
  }

  @media (max-width: 667px) {
    margin-right: 0;
  }

  ${(props) =>
    props.onClick &&
    css`
      cursor: pointer;
    `}
`;

export const SkillHeader = styled.h5`
  position: absolute;
  top: 10px;
  left: 10px;
  text-transform: uppercase;
  color: ${colors.gray2};
  font-weight: 300;
  font-size: 18px;
  margin: 0;
  user-select: none;
`;

export const Circle = styled.div`
  color: ${colors.white};
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: ${(props) => props.color};
  border-radius: 50%;
  font-size: 34px;
  line-height: 34px;
  font-weight: bold;
  width: 80px;
  height: 80px;
  user-select: none;
  margin: ${(props) => (props.margin ? `${props.margin}` : '0px')};

  ${(props) =>
    props.size &&
    css`
      width: ${props.size}px;
      height: ${props.size}px;
      font-size: ${Math.round(props.size / 2)}px;
    `}
`;

export const TrophyWrapper = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  padding: 35px 25px 0;
  justify-content: space-between;
`;

export const TrophyContainer = styled.div`
  width: 90px;
  height: 130px;
  background: linear-gradient(rgba(255, 255, 255, 0), #dedede);
  border-bottom-left-radius: 50px;
  border-bottom-right-radius: 50px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
  padding-top: 10px;
`;

export const TrophyTitle = styled.span`
  text-transform: uppercase;
  color: ${colors.gray2};
  font-weight: 300;
  font-size: 14px;
  margin-bottom: 2px;
  user-select: none;
`;

export const TrophyIcon = styled.div`
  width: ${(props) => (props.size ? `${props.size}px` : '65px')};
  height: ${(props) => (props.size ? `${props.size}px` : '65px')};
  border-radius: 50%;
  position: relative;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  ${(props) =>
    !props.size &&
    css`
      box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.3);
    `}

  :before {
    content: '';
    position: absolute;
    background: ${colors.fsLightBlue};
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    z-index: -1;
  }

  :after {
    content: '${(props) => props.icon || '\f091'}';
    font-family: FontAwesome;
    position: absolute;
    color: ${colors.white};
    opacity: 0.75;
    font-size: ${(props) => (props.size ? `${props.size * 0.55}px` : '42px')};
  }

  ${(props) =>
    props.rgb &&
    css`
      background: linear-gradient(
        -45deg,
        rgb(${props.rgb.r}, ${props.rgb.g}, ${props.rgb.b}),
        rgba(${props.rgb.r}, ${props.rgb.g}, ${props.rgb.b}, 0.2),
        rgb(${props.rgb.r}, ${props.rgb.g}, ${props.rgb.b})
      );
      border: ${props.size ? Math.round((props.size / 65) * 3) : 3}px solid
        rgb(${props.rgb.r}, ${props.rgb.g}, ${props.rgb.b});
    `}
`;

export const TrophyAmount = styled.span`
  font-size: 16px;
  color: ${colors.gray2};
  user-select: none;
`;

export const RankTitle = styled.span`
  color: ${colors.fsDarkBlue};
  font-size: 20px;
  margin-bottom: 10px;
  text-transform: capitalize;
`;

export const RankIcon = styled.div`
  background: ${colors.fsDarkBlue};
  color: ${colors.white};
  width: 80px;
  height: 80px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  margin-bottom: 10px;
  :after {
    content: '\f106';
    font-family: FontAwesome;
    font-size: 70px;
  }
`;

export const RankDescription = styled.span`
  color: ${colors.fsDarkBlue};
  font-size: 14px;
  margin-bottom: 10px;
`;

export const AchievementWrapper = styled.div`
  width: 100%;
  height: 100%;
  padding-top: 30px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const MaxAchievementsText = styled.span`
  color: ${colors.white};
  font-size: 12px;
  line-height: 12px;
`;

export const LatestAchievementText = styled.span`
  color: ${colors.lightGray2};
  font-size: 14px;
  margin-right: 3px;
`;

export const LatestAchievementContainer = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 10px;
  margin-top: 10px;
`;

export const InfoSectionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  @media (max-width: 667px) {
    flex-wrap: wrap;
    flex-direction: row;
    justify-content: space-between;
  }
`;

export const ActivityWrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  padding-top: 20px;
`;

export const ActivityContainer = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column-reverse;
  align-items: center;
  justify-content: flex-start;
`;

export const ActivityDivider = styled.div`
  flex: 0 0 1px;
  height: 100%;
  background: linear-gradient(rgba(0, 0, 0, 0), #dedede);
`;

export const ActivityTitle = styled.span`
  color: ${colors.lightGray2};
  text-transform: capitalize;
  font-weight: 300;
  font-size: 14px;
  margin: 3px 0 5px;
  user-select: none;
`;

export const TabContainer = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 30px;
  padding: 0 10px 5px;
  font-weight: 300;
  border-bottom: 1px solid #dedede;

  @media (max-width: 667px) {
    flex-direction: column;
    width: 95vw;
    padding: 0 5px 15px;
  }
`;

export const TabIcon = styled.div`
  width: 20px;
  margin-right: 8px;
  display: flex;
  justify-content: center;
  :after {
    content: '${(props) => props.icon}';
    font-family: FontAwesome;
    font-size: 20px;
    line-height: 20px;
  }
`;

export const TabTitle = styled.div`
  font-size: 20px;
  display: flex;
  align-items: center;
  line-height: 28px;
  cursor: pointer;
  color: #888;
  text-transform: uppercase;
  margin-right: 60px;

  :last-child {
    margin-right: 0;
  }
  ${(props) =>
    props.isActive &&
    css`
      color: ${colors.fsDarkBlue};
    `}
  :hover {
    color: ${colors.fsDarkBlue};
  }
`;

export const ChallengeSticker = styled.div`
  background: url(${(props) => props.image});
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
  display: flex;
  justify-content: space-between;
  width: 100%;
  margin: 5px 0 5px;
  margin-top: 5px !important;
  border-radius: 5px;
  overflow: hidden;
  padding: 7px;
  position: relative;
  height: 90px;
  flex: 1 0 70px;
  user-select: none;
  @media (max-width: 667px) {
    height: auto;
    min-height: 90px;
  }
  :after {
    content: '';
    background: rgba(50, 50, 50, 0.5);
    position: absolute;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
  }

  :first-child {
    margin-top: 0;
  }

  :last-child {
    margin-bottom: 0;
  }
`;

export const ChallengeStickerContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  z-index: 1;
`;

export const ExerciseStickerContent = styled.div`
  display: flex;
  flex-direction: column;
  z-index: 1;
`;

export const ChallengeStickerHeader = styled.div`
  display: flex;
`;

export const ChallengeStickerTimeLeft = styled.span`
  color: #555;
  background: rgba(255, 255, 255, 0.7);
  border-radius: 2px;
  font-size: 12px;
  line-height: 12px;
  padding: 4px 5px;
  margin-right: 5px;
`;

export const ChallengeName = styled.span`
  text-transform: uppercase;
  color: ${colors.white};
  font-size: 20px;
  line-height: 20px;
  @media (max-width: 667px) {
    width: min-content;
  }
`;

export const ChallengeScore = styled.span`
  text-transform: uppercase;
  color: ${colors.white};
  font-size: 14px;
  line-height: 20px;
`;

export const ExerciseLanguageContent = styled.span`
  color: ${colors.white};
  font-size: 14px;
  line-height: 20px;
  padding-top: 6px;
`;

export const ChallengeStickerTrophy = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  z-index: 1;
  width: 50px;
  padding: 1px 0;
`;

export const ChallengeContainer = styled.div`
  margin: 40px 0 0;
  padding: 0 15px 15px;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  overflow-y: auto;
`;

export const ExercisesContainer = styled.div`
  margin: 40px 0 0;
  padding: 0 15px 15px;
  display: inline-block;
  flex-direction: column;
  width: 100%;
  height: 100%;
  overflow-y: auto;
`;

export const ExerciseLink = styled(RouterLink)`
  text-decoration: none;
  color: unset;
  display: inline-block;
  padding: 5px;
  width: 50%;
  @media (max-width: 667px) {
    width: 100%;
  }
  :hover {
    color: unset;
    text-decoration: none;
  }
`;

export const ChallengeEmptyText = styled.span`
  font-size: 14px;
  color: ${colors.darkGray};
`;

export const FriendAvatar = styled.div`
  background: url(${(props) => props.image});
  background-position: center center;
  background-size: cover;
  background-repeat: no-repeat;
  border-radius: 50%;
  width: ${(props) => props.size || '42'}px;
  height: ${(props) => props.size || '42'}px;
  margin-right: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: ${(props) => props.size / 2 || '18'}px;
  color: ${colors.white};
  font-weight: bold;
  text-shadow:
    -1px 0 black,
    0 1px black,
    1px 0 black,
    0 -1px black;
  user-select: none;
`;

export const FriendTable = styled.table`
  overflow-y: scroll;
`;

export const FriendTableRow = styled.tr`
  background: #efefef;
  border-bottom: 1px solid ${colors.white};

  :last-child {
    border-bottom: none;
  }

  ${(props) =>
    props.alternateRow &&
    css`
      background: #dedede;
    `}

  ${(props) =>
    props.isSelf &&
    css`
      background: #c7dded;
    `}
`;

export const FriendTableHead = styled.thead``;

export const FriendTableBody = styled.tbody``;

export const FriendTableHeader = styled.th`
  text-align: left;
  color: #888;
  font-weight: 300;
  padding: 5px 0;
  position: sticky;
  top: 0;
  z-index: 2;
  background: ${colors.white};
  user-select: none;

  :first-child {
    padding-left: 10px;
    width: 60px;
  }

  ${(props) =>
    props.width &&
    css`
      width: ${props.width}px;
    `}

  ${(props) =>
    props.center &&
    css`
      text-align: center;
    `}
`;

export const FriendTableCell = styled.td`
  text-align: left;
  height: 55px;
  padding: 0;

  :first-child {
    padding-left: 7px;
  }

  :last-child {
    > div {
      padding: 0;
    }
  }
`;

export const FriendName = styled.span`
  font-size: 18px;
  color: #555;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  ${(props) =>
    props.isSelf &&
    css`
      font-weight: bold;
    `}
`;

export const FriendChallenge = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${(props) => props.color};
  font-weight: bold;
  color: ${colors.white};
  height: 100%;
  font-size: 18px;

  ${(props) =>
    props.narrow &&
    css`
      width: 45px;
    `}

  ${(props) =>
    props.spaced &&
    css`
      letter-spacing: 1px;
    `}
`;

export const FriendChallengeText = styled.span`
  flex: 1 1 25%;

  ${(props) =>
    props.left &&
    css`
      text-align: right;
    `}
  ${(props) =>
    props.center &&
    css`
      text-align: center;
      font-size: 10px;
      flex: 0 1 20%;
    `}
`;

export const ChallengeParticipants = styled.span`
  color: ${colors.white};
  font-size: 14px;
  line-height: 18px;

  :before {
    content: '\f007';
    font-family: FontAwesome;
    font-size: 16px;
    margin-right: 5px;
  }
`;

export const PlacementLabel = styled.span`
  color: ${colors.white};
  margin-top: auto;
  font-size: 13px;
  line-height: 13px;
`;

export const ChallengeDate = styled.span`
  color: ${colors.white};
  font-size: 13px;
  margin-right: 5px;
`;

export const ItemContainer = styled.div`
  display: flex;
  height: 30px;
  align-items: center;
  font-size: 14px;
`;

export const LevelsHeader = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  color: ${colors.white};
  padding: 5px;
  font-size: 14px;
  z-index: 1;
`;

export const EmailUpdatesLabelAndCheckbox = styled.div`
  display: inline-flex;
  cursor: pointer;
  margin-top: 15px;
`;

export const EmailUpdatesInputCheckbox = styled.input`
  height: 20px;
  width: 20px;
`;

export const EmailUpdatesLabel = styled.label`
  margin-left: 0.5rem !important;
`;

export const CourseContainer = styled(BaseContainer)`
  width: 80%;
  flex-direction: column;

  @media (max-width: 667px) {
    padding-top: 10px;
    display: block;
  }
`;
